import React from "react";
import { makeStyles } from '@material-ui/core/styles';

import Container from "../../../../base/components/container.js";
import I18n from "../../../../base/i18n.js.jsx";

import IcHouse from "../resources/icons/ic_house.js";
import IcCoins from "../resources/icons/ic_coins.js";
import IcMoney from "../resources/icons/ic_money.js";

const blockStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.white,
    color: theme.palette.blueMain
  },
  content: {
    padding: "36px 16px 45px",
    ['@media (max-width: 992px)']: {
      padding: "26px 16px",
    },
    ['@media (max-width: 768px)']: {
      padding: "20px 24px 16px",
    },
  },
  columnsContainer: {
    display: "flex",
    justifyContent: "space-between"
  },
  column: {
    display: "flex",
    padding: "0px 20px",
    "&:first-child": {
      paddingLeft: "0px",
      ['@media (max-width: 768px)']: {
        "& $columnContent $uom": {
          display: "none"
        },

        "& $columnContent $columnText": {
          "&:before": {
            content: `'${I18n.t("web.page.index.values.columns.projects.uom")} '`
          }
        },
      }
    },
    "&:last-child": {
      paddingRight: "0px"
    },
    ['@media (max-width: 768px)']: {
      padding: "0px 7px"
    }
  },
  columnIcon: {
    marginRight: "17px",
    display: "flex",
    ['@media (max-width: 992px)']: {
      alignItems: "center"
    },
    ['@media (max-width: 768px)']: {
      alignItems: "flex-start",
      marginRight: "3px"
    },
  },
  icon: {
    ['@media (max-width: 992px)']: {
      width: "45px",
      height: "45px",
    },
    ['@media (max-width: 768px)']: {
      width: "25px",
      height: "25px"
    }
  },
  columnContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    ['@media (max-width: 768px)']: {
      justifyContent: "flex-start"
    },
  },
  columnValue: {
    fontSize: "30px",
    lineHeight: "30px",
    marginBottom: "10px",
    ['@media (max-width: 992px)']: {
      fontSize: "20px",
      lineHeight: "22px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "18px",
      height: "28px",
      marginBottom: "0",
      padding: "3px 0",
      whiteSpace: "nowrap",

      "& $uom": {
        fontSize: "9px",
        marginLeft: "3px"
      }
    }
  },
  value: {
    "&:after": {
      content: "' '",
      ['@media (max-width: 768px)']: {
        content: "''"
      }
    }
  },
  uom: {
  },
  columnText: {
    fontSize: "20px",
    lineHeight: "24px",

    ['@media (max-width: 992px)']: {
      fontSize: "14px",
      lineHeight: "16px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "11px",
      lineHeight: "14px",
      marginLeft: "-25px",
      maxWidth: "70px"
    }
  },
}));

const ValuesBlock = () => {
  const classes = blockStyles();

  let columns = [
    {
      icon: <IcHouse className = { classes.icon }/>,
      value: I18n.t("web.page.index.values.columns.projects.value"),
      uom: I18n.t("web.page.index.values.columns.projects.uom"),
      text: I18n.t("web.page.index.values.columns.projects.text")
    },
    {
      icon: <IcCoins className = { classes.icon }/>,
      value: I18n.t("web.page.index.values.columns.invested_capital.value"),
      uom: I18n.t("web.page.index.values.columns.invested_capital.uom"),
      text: I18n.t("web.page.index.values.columns.invested_capital.text")
    },
    {
      icon: <IcMoney className = { classes.icon }/>,
      value: I18n.t("web.page.index.values.columns.repaid_capital.value"),
      uom: I18n.t("web.page.index.values.columns.repaid_capital.uom"),
      text: I18n.t("web.page.index.values.columns.repaid_capital.text")
    }
  ];

  return <div className = { classes.root } >
    <Container className = { classes.content }>
      <div className = { classes.columnsContainer } >
        {
          columns.map((column, index) => {
            const { icon, text, value, uom } = column;
            return <div className = { classes.column }
                        key = { index } >
              <div className = { classes.columnIcon } >
                { icon }
              </div>
              <div className = { classes.columnContent } >
                <div className = { classes.columnValue } >
                  <span className = { classes.value } >
                    { value }
                  </span>
                  <span className = { classes.uom } >
                    { uom }
                  </span>
                </div>
                <span className = { classes.columnText } >
                  { text }
                </span>
              </div>
            </div>
          })
        }
      </div>
    </Container>
  </div>
};

export default ValuesBlock;
